import { CSSProperties, FC } from 'react';

import { IconColor, iconColors } from './helpers';
import svgPaths from './svg-data';
import { IconName } from './types';
import { getSemanticColorVariable } from '../../../v2/theme/colors';

// Local Typings
export type IconSize = 'lg' | 'md' | 'sm' | 'xl' | 'xs' | 'xxl' | 'xxs' | 'xxxs';

export interface IconProps {
  color?: IconColor;
  name: IconName;
  size?: IconSize;
}

// Local Variables
const iconSizes: Record<IconSize, string> = {
  lg: '52px',
  md: '40px',
  sm: '32px',
  xl: '75px',
  xs: '24px',
  xxl: '132px',
  xxs: '16px',
  xxxs: '12px',
};

// Component Definition
const Icon: FC<IconProps> = ({
  color = 'default',
  name,
  size = 'xxs',
}) => {
  const svgSize = iconSizes[size];
  const style: CSSProperties = { ['--icon-color' as string]: getSemanticColorVariable(iconColors[color]) };

  return (
    <svg
      className="icon"
      height={svgSize}
      style={style}
      viewBox="0 0 16 16"
      width={svgSize}
      xmlns="http://www.w3.org/2000/svg"
    >
      {svgPaths[name]}
    </svg>
  );
};

export default Icon;
